import { MarketSignal } from '@/modules/market-signals/model/market-signals/market-signal';
import dayjs from 'dayjs';
import { MarketSignalSourceText } from '@/modules/market-signals/components/market-signals/market-signal-source-badge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faImage, faVideo, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import MarketSignalClipboardButton from '@/modules/market-signals/components/market-signals/market-signal-clipboard-button';
import '@/modules/market-signals/components/trump-tracker/trump-tracker-scroller-entry.scss';

const isOld = (truth: MarketSignal) => {
  return !dayjs(truth.dateCreated).isSame(dayjs(), 'day');
};

export default function TrumpTrackerScrollerEntry({ truth }: { truth: MarketSignal }) {
  const iconMap: Record<string, IconDefinition> = {
    image: faImage,
    photo: faImage,
    video: faVideo,
    animated_gif: faVideo,
    article: faEnvelope,
  };

  const openMedia = (e: React.MouseEvent<HTMLAnchorElement>, url: string) => {
    e.stopPropagation();
    e.preventDefault();
    window.open(url, 'ms-popup', 'width=600,height=400');
  };

  return (
    <div className={`py-1 ${isOld(truth) ? 'bg-body-tertiary' : ''}`}>
      <>
        <div className={`d-flex justify-content-between`}>
          <div className={'font-monospace text-muted'}>
            <strong className={'text-body'}>{dayjs(truth.dateCreated).format('h:mma')}</strong> -{' '}
            <MarketSignalSourceText source={truth.sourcePlatform}>
              {truth.infoSources.map(s => s.name).join(', ')}
            </MarketSignalSourceText>
          </div>
          <div className="px-1">
            <MarketSignalClipboardButton signal={truth} />
          </div>
        </div>
        {isOld(truth) && (
          <div className={'font-monospace text-warning-emphasis'}>
            <strong>{dayjs(truth.dateCreated).format('MMM D')}</strong>{' '}
            <span>({dayjs(truth.dateCreated).fromNow()})</span>{' '}
          </div>
        )}
      </>
      <div
        className="trump-tracker-container"
        dangerouslySetInnerHTML={{ __html: truth.headline }}
      />
      {truth.body && (
        <div>
          <div>
            <a
              href={'#a'}
              onClick={event => {
                event.stopPropagation();
                event.preventDefault();
              }}
            >
              Read More
            </a>
          </div>
        </div>
      )}

      {truth.mediaAttachments?.length > 0 && (
        <>
          {truth.mediaAttachments.map((value, index) => (
            <div key={index}>
              <a href={`#a`} onClick={event => openMedia(event, value.url)}>
                <FontAwesomeIcon icon={iconMap[value.type] || faImage} /> Open Media ({value.type})
              </a>
            </div>
          ))}
        </>
      )}
    </div>
  );
}
